module.exports = __webpack_public_path__ + "ta.png?7bb6334eea0f10b24ea7d37e2ead0d5a";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/ta.png
// module id = 199
// module chunks = 0